import { motion } from "framer-motion";
import SectionHeader from "./SectionHeader";

const MESSAGING_FEATURES = [
  {
    icon: "send",
    title: "직접 전송 방식",
    desc: "이동통신사를 거쳐 직접 발송하여\n빠르고 안정적인 전송",
  },
  {
    icon: "security",
    title: "게이트웨이 이중화",
    desc: "완벽한 이중화로 장애 리스크\n없는 확실한 메시지 전달을 보장",
  },
  {
    icon: "dashboard",
    title: "관리자 정산 시스템",
    desc: "충전 · 사용 내역 · 타입별\n통계를 실시간으로 확인 및 관리",
  },
  {
    icon: "phone_callback",
    title: "015 발신번호 제공",
    desc: "계약 후 별도 준비 없이\n즉시 사용 가능한 015번호 제공",
  },
];

const MessagingSection = () => {
  return (
    <section className="py-12 sm:py-24 bg-[#B0BEE2] bg-opacity-20">
      <div className="max-w-[132rem] mx-auto px-4 sm:px-8">
        {/* 섹션 헤더 */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <SectionHeader
            title={
              <>
                안정적인 <span className="text-[#1976D2]">메시징</span>, 먼저 직접 써보세요
              </>
            }
            description=""
            buttonText="서비스 알아보기"
            buttonTo="/service-provide/messaging"
          />
          <div className="grid grid-cols-1 sm:grid-cols-4">
            <p className="text-[1.3rem] sm:text-[1.6rem] md:text-[1.8rem] col-span-1 sm:col-span-3 font-medium text-gray-500 leading-relaxed">
              서비스 도입 전, 실제 환경과 동일한 조건에서
              <br />
              충분히 경험해 보고 결정하세요.
            </p>
            {/* 일러스트 이미지 */}
            <div className="relative flex-shrink-0 hidden col-span-1 md:block top-10 -left-1/4">
              <img
                src="/img/home/messaging/msg_01.png"
                alt="메시징 서비스 일러스트"
                className="object-contain w-3/4 h-auto "
              />
            </div>
          </div>

          {/* 4가지 장점 카드 */}
          <div className="relative grid grid-cols-1 gap-3 mb-10 sm:grid-cols-2 sm:gap-4 md:grid-cols-4 z-1">
            {MESSAGING_FEATURES.map((item, idx) => (
              <div
                key={idx}
                className="px-4 py-6 bg-white border border-gray-100 rounded sm:px-8 sm:py-14"
              >
                <div className="flex flex-col items-start gap-2 mb-4 sm:flex-row sm:items-center sm:gap-4">
                  <span className="material-icons-round text-[2rem] sm:text-[2.4rem] text-[#1976D2] block">
                    {item.icon}
                  </span>
                  <h3 className="text-[1.6rem] sm:text-[2rem] font-bold text-gray-800 mb-1">
                    {item.title}
                  </h3>
                </div>
                <p className="text-[1.3rem] sm:text-[1.6rem] whitespace-pre-line leading-relaxed">
                  {item.desc}
                </p>
              </div>
            ))}
          </div>
        </motion.div>

        {/* 알림톡/브랜드메시지 & RCS */}

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <div className="grid grid-cols-1 gap-5 mt-16 sm:mt-32 md:grid-cols-2">
            {/* 알림톡 / 브랜드메시지 */}
            <div className="flex items-center gap-4">
              <div className="flex-1">
                <h3 className="text-[1.8rem] sm:text-[2.4rem] font-bold px-6 sm:px-12 py-4 sm:py-8 text-[#032C6D] mb-1">
                  알림톡 / 브랜드메시지
                </h3>
                <div className="relative flex bg-white rounded-lg">
                  <p className="text-[1.4rem] sm:text-[2rem] flex-1 p-6 sm:p-12 text-gray-500 leading-relaxed">
                    정보성 메시지는 정확하고
                    <br />
                    브랜드 마케팅은 효과적으로
                  </p>
                  <div className="relative flex-1">
                    <img
                      src="/img/home/messaging/msg_03.png"
                      alt="알림톡 브랜드메시지"
                      className="absolute bottom-0 left-0 flex-shrink-0 object-contain h-auto"
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* RCS */}
            <div className="flex items-center gap-4">
              <div className="flex-1">
                <h3 className="text-[1.8rem] sm:text-[2.4rem] font-bold px-6 sm:px-12 py-4 sm:py-8 text-[#032C6D] mb-1">
                  RCS
                </h3>
                <div className="relative flex bg-white rounded-lg">
                  <p className="text-[1.4rem] sm:text-[2rem] flex-1 p-6 sm:p-12 text-gray-500 leading-relaxed">
                    풍부한 콘텐츠로 소통하는
                    <br />
                    차세대 메시징 서비스
                  </p>
                  <div className="relative flex-1">
                    <img
                      src="/img/home/messaging/msg_02.png"
                      alt="알림톡 브랜드메시지"
                      className="absolute bottom-0 left-0 flex-shrink-0 object-contain h-auto"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default MessagingSection;
